<template>
  <v-dialog
    :value="reviewImageDialog"
    @input="$emit('update:reviewImageDialog', $event)"
    width="600"
    persistent
    @click:outside="$emit('cancel-review-image')"
  >
    <v-card>
      <v-card-title>
        {{ editingImageIndex !== null ? 'Edit Review Image' : 'Add Review Image' }}
      </v-card-title>
      <v-card-text>
        <UploadImage
          @callback="$emit('review-image-uploaded', $event)"
          :image="{ imageSrc: currentReviewImage.src }"
          :height="`300`"
          :typeUpload="'image'"
          @callbackDelete="$emit('remove-review-image-dialog')"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('cancel-review-image')">Cancel</v-btn>
        <v-btn color="primary" @click="$emit('save-review-image')">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';

export default {
  name: 'ReviewImageDialog',
  components: { UploadImage },
  props: {
    reviewImageDialog: { type: Boolean, required: true },
    editingImageIndex: { type: [Number, null], default: null },
    currentReviewImage: { type: Object, required: true },
  },
};
</script>

<style scoped lang="scss"></style>
